import { render, staticRenderFns } from "./Royerssluis.vue?vue&type=template&id=7489560c&"
import script from "./Royerssluis.vue?vue&type=script&lang=ts&"
export * from "./Royerssluis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports